import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { Dialog, HlmDialogDescriptionDirective, HlmDialogFooterComponent, HlmDialogHeaderComponent, HlmDialogTitleDirective } from '@spartan-ng/ui-dialog-helm';

type Context = Record<string, never>;

type Result = {
    confirmed: boolean;
};

@Component({
    selector: 'sona-end-trial-dialog',
    standalone: true,
    imports: [
        TranslatePipe,
        HlmButtonDirective,
        HlmDialogHeaderComponent,
        HlmDialogFooterComponent,
        HlmDialogDescriptionDirective,
        HlmDialogTitleDirective
    ],
    template: `
        <hlm-dialog-header>
            <h1 hlmDialogTitle>
                {{ 'PAYMENTS.DIALOG.END_TRIAL.TITLE' | translate }}
            </h1>
            <p hlmDialogDescription>
                {{ 'PAYMENTS.DIALOG.END_TRIAL.DESCRIPTION' | translate }}
            </p>
        </hlm-dialog-header>
        <hlm-dialog-footer class="tw-mt-8">
            <button
                hlmBtn
                variant="secondary"
                type="button"
                (click)="cancel()"
            >
                {{ 'PAYMENTS.DIALOG.END_TRIAL.ACTION.CANCEL' | translate }}
            </button>
            <button
                hlmBtn
                type="submit"
                (click)="closeWithResult({ confirmed: true })"
            >
                {{ 'PAYMENTS.DIALOG.END_TRIAL.ACTION.CONFIRM' | translate }}
            </button>
        </hlm-dialog-footer>
    `
})
export class SonaEndTrialDialog extends Dialog<Context, Result> {}
